import { eventsFlux, EventTypes, nodesFlux, ROOT_NODE, useEditorSelector } from '@candulabs/craft';
import { useEffect, useMemo } from 'react';
import { createStructuredSelector } from 'reselect';

import useNodeContext from './useNodeContext';

const isRootSelectedSelector = eventsFlux.selectors.doesNodeHaveEvent(
  ROOT_NODE,
  EventTypes.selected,
);

const useDomFocus = () => {
  const { id } = useNodeContext();
  const nodeSelector = useMemo(
    () =>
      createStructuredSelector({
        isSelected: eventsFlux.selectors.doesNodeHaveEvent(id, EventTypes.selected),
        dom: nodesFlux.selectors.getNodeDom(id),
      }),
    [id],
  );
  const { isSelected, dom } = useEditorSelector(nodeSelector);
  const isRootSelected = useEditorSelector(isRootSelectedSelector);

  useEffect(() => {
    if (!dom) {
      return;
    }

    const selected = isSelected || isRootSelected;

    if (!selected) {
      return;
    }

    // We need this because sometimes React remounts a new DOM element
    // In which case, the mouse focus will be lost and thus we need to manually re-focus the new DOM when it's available
    const isDOMFocusLost = !document.activeElement?.closest('#viewport');

    // Manually focus on the DOM element if the current element has been selected
    if (isDOMFocusLost) {
      // check if focus is somewhere within document to prevent
      // accidentally stealing focus from other places
      // focus dom, dont scroll if its root node
      dom.focus({ preventScroll: isRootSelected });
    }
  }, [dom, isSelected, isRootSelected]);
};

export default useDomFocus;
